export default __webpack_public_path__ + "static/media/icon-3.7d83b399.svg";